import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/ui/dialog';
import { Button } from '@shadcn/components/ui/button';
import type { ReleaseNote } from 'types/releaseNotes';

interface Props {
  isOpen: boolean;
  releaseNote: ReleaseNote | null;
  onClose: () => void;
}

export function PostUpdateReleaseNotesDialog({ isOpen, releaseNote, onClose }: Props) {
  const { t } = useTranslation();

  if (!releaseNote) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent showCloseButton={false} className="max-w-md w-[90vw]">
        <DialogHeader>
          <DialogTitle>
            {t('releaseNotes.postUpdateDialog.title', { version: releaseNote.version })}
          </DialogTitle>
          {releaseNote.releaseDate && (
            <DialogDescription>
              {new Intl.DateTimeFormat(undefined, { dateStyle: 'long' }).format(
                new Date(releaseNote.releaseDate)
              )}
            </DialogDescription>
          )}
        </DialogHeader>

        <ol className="space-y-3 py-2 max-h-[75vh] overflow-y-auto pr-2">
          {[...releaseNote.entries]
            .sort((a, b) => a.order - b.order)
            .map((entry, index) => (
              <li key={entry.id} className="flex gap-3 text-sm">
                <span className="text-muted-foreground shrink-0">{index + 1}.</span>
                <span>
                  <span className="font-medium">{entry.title}</span>
                  {entry.body && <span className="text-muted-foreground"> — {entry.body}</span>}
                </span>
              </li>
            ))}
        </ol>

        <DialogFooter>
          <Button onClick={onClose}>{t('releaseNotes.postUpdateDialog.close')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
